/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const getAccommodation = /* GraphQL */ `
  query GetAccommodation($id: ID!) {
    getAccommodation(id: $id) {
      id
      owner
      postId
      tripId
      title
      details
      accommodationType
      otherAccommodationType
      hotelName
      address
      link
      cost
      costDistributionType
      checkInDate
      checkOutDate
      participants {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAccommodations = /* GraphQL */ `
  query ListAccommodations(
    $filter: ModelAccommodationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccommodations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAccommodationParticipant = /* GraphQL */ `
  query GetAccommodationParticipant($id: ID!) {
    getAccommodationParticipant(id: $id) {
      id
      userId
      accommodationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAccommodationParticipants = /* GraphQL */ `
  query ListAccommodationParticipants(
    $filter: ModelAccommodationParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccommodationParticipants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        accommodationId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      id
      owner
      postId
      tripId
      title
      details
      activeDate
      potentialDates
      address
      duration
      cost
      link
      costDistributionType
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      participants {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listActivitys = /* GraphQL */ `
  query ListActivitys(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getActivityParticipant = /* GraphQL */ `
  query GetActivityParticipant($id: ID!) {
    getActivityParticipant(id: $id) {
      id
      userId
      activityId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listActivityParticipants = /* GraphQL */ `
  query ListActivityParticipants(
    $filter: ModelActivityParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityParticipants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        activityId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getBetaKey = /* GraphQL */ `
  query GetBetaKey($id: ID!) {
    getBetaKey(id: $id) {
      id
      owner
      userId
      email
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listBetaKeys = /* GraphQL */ `
  query ListBetaKeys(
    $filter: ModelBetaKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBetaKeys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        userId
        email
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      postId
      postIdCommentType
      owner
      repliedToCommentId
      comment
      isReplyComment
      repliedToComment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      replyComments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          owner
          commentId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      email
      isUser
      title
      details
      category
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        isUser
        title
        details
        category
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFlight = /* GraphQL */ `
  query GetFlight($id: ID!) {
    getFlight(id: $id) {
      id
      postId
      tripId
      owner
      title
      details
      cost
      participants {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          flightId
          tripId
          owner
          departTime
          arrivalTime
          airline
          flightNumber
          departureAirport
          arrivalAirport
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFlights = /* GraphQL */ `
  query ListFlights(
    $filter: ModelFlightFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFlights(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFlightInformation = /* GraphQL */ `
  query GetFlightInformation($id: ID!) {
    getFlightInformation(id: $id) {
      id
      flightId
      tripId
      owner
      departTime
      arrivalTime
      airline
      flightNumber
      departureAirport
      arrivalAirport
      flightPost {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFlightInformations = /* GraphQL */ `
  query ListFlightInformations(
    $filter: ModelFlightInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFlightInformations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        flightId
        tripId
        owner
        departTime
        arrivalTime
        airline
        flightNumber
        departureAirport
        arrivalAirport
        flightPost {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFlightParticipant = /* GraphQL */ `
  query GetFlightParticipant($id: ID!) {
    getFlightParticipant(id: $id) {
      id
      userId
      flightId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFlightParticipants = /* GraphQL */ `
  query ListFlightParticipants(
    $filter: ModelFlightParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFlightParticipants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        flightId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFriendship = /* GraphQL */ `
  query GetFriendship($id: ID!) {
    getFriendship(id: $id) {
      id
      primaryUserId
      primaryUser {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      secondaryUserId
      secondaryUser {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      friendshipStatus
      createdAt
      updatedAt
    }
  }
`;
export const listFriendships = /* GraphQL */ `
  query ListFriendships(
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFriendships(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPostLike = /* GraphQL */ `
  query GetPostLike($id: ID!) {
    getPostLike(id: $id) {
      id
      postId
      owner
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listPostLikes = /* GraphQL */ `
  query ListPostLikes(
    $filter: ModelPostLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPostLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        postId
        owner
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCommentLike = /* GraphQL */ `
  query GetCommentLike($id: ID!) {
    getCommentLike(id: $id) {
      id
      owner
      commentId
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCommentLikes = /* GraphQL */ `
  query ListCommentLikes(
    $filter: ModelCommentLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommentLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        commentId
        comment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotificationSetting = /* GraphQL */ `
  query GetNotificationSetting($id: ID!) {
    getNotificationSetting(id: $id) {
      id
      notificationSettingType
      notificationType
      createdAt
      updatedAt
    }
  }
`;
export const listNotificationSettings = /* GraphQL */ `
  query ListNotificationSettings(
    $filter: ModelNotificationSettingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        notificationSettingType
        notificationType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      owner
      notificationType
      notificationStatus
      ownerStatusKey
      tripInvitationId
      friendshipId
      userId
      tripId
      commentId
      postId
      tripInvitation {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      friendship {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        notificationType
        notificationStatus
        ownerStatusKey
        tripInvitationId
        friendshipId
        userId
        tripId
        commentId
        postId
        tripInvitation {
          id
          owners
          senderId
          recipientId
          tripId
          permissionType
          status
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        comment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        friendship {
          id
          primaryUserId
          secondaryUserId
          friendshipStatus
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPost = /* GraphQL */ `
  query GetPost($id: ID!) {
    getPost(id: $id) {
      id
      owner
      activityId
      accommodationId
      transportationId
      flightId
      tripId
      postType
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          postId
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listPosts = /* GraphQL */ `
  query ListPosts(
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getResource = /* GraphQL */ `
  query GetResource($id: ID!) {
    getResource(id: $id) {
      id
      owner
      resourceName
      description
      resourcePath
      createdAt
      updatedAt
    }
  }
`;
export const listResources = /* GraphQL */ `
  query ListResources(
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        resourceName
        description
        resourcePath
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTransportation = /* GraphQL */ `
  query GetTransportation($id: ID!) {
    getTransportation(id: $id) {
      id
      owner
      tripId
      postId
      title
      transportationType
      details
      company
      pickUpDate
      dropOffDate
      vehicleType
      vehicleMake
      vehicleModel
      vehicleYear
      numberOfSeats
      pickUpLocation
      destination
      link
      cost
      typeOfPublicTransportation
      typeOfTransportation
      costDistributionType
      participants {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTransportations = /* GraphQL */ `
  query ListTransportations(
    $filter: ModelTransportationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransportations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTransportationParticipant = /* GraphQL */ `
  query GetTransportationParticipant($id: ID!) {
    getTransportationParticipant(id: $id) {
      id
      userId
      transportationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTransportationParticipants = /* GraphQL */ `
  query ListTransportationParticipants(
    $filter: ModelTransportationParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransportationParticipants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        transportationId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTrip = /* GraphQL */ `
  query GetTrip($id: ID!) {
    getTrip(id: $id) {
      id
      tripName
      destination
      startDate
      endDate
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      members {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      activities {
        items {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodations {
        items {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        nextToken
      }
      transportations {
        items {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        nextToken
      }
      posts {
        items {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTrips = /* GraphQL */ `
  query ListTrips(
    $filter: ModelTripFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrips(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTripMember = /* GraphQL */ `
  query GetTripMember($id: ID!) {
    getTripMember(id: $id) {
      id
      userId
      tripId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      permissionType
      createdAt
      updatedAt
    }
  }
`;
export const listTripMembers = /* GraphQL */ `
  query ListTripMembers(
    $filter: ModelTripMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTripMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        tripId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        permissionType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTripInvitation = /* GraphQL */ `
  query GetTripInvitation($id: ID!) {
    getTripInvitation(id: $id) {
      id
      owners
      senderId
      recipientId
      tripId
      permissionType
      status
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      recipient {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTripInvitations = /* GraphQL */ `
  query ListTripInvitations(
    $filter: ModelTripInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTripInvitations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      name
      trips {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      activityParticipant {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodationParticipant {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      flightParticipant {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      transportationParticipant {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      profilePicture
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserPii = /* GraphQL */ `
  query GetUserPii($id: ID!) {
    getUserPII(id: $id) {
      id
      email
      phoneNumber
      birthDate
      createdAt
      updatedAt
    }
  }
`;
export const listUserPiIs = /* GraphQL */ `
  query ListUserPiIs(
    $filter: ModelUserPIIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPIIs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        phoneNumber
        birthDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWaitListEmail = /* GraphQL */ `
  query GetWaitListEmail($id: ID!) {
    getWaitListEmail(id: $id) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const listWaitListEmails = /* GraphQL */ `
  query ListWaitListEmails(
    $filter: ModelWaitListEmailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWaitListEmails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accommodationByTripId = /* GraphQL */ `
  query AccommodationByTripId(
    $tripId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccommodationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accommodationByTripId(
      tripId: $tripId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accommodationByPostId = /* GraphQL */ `
  query AccommodationByPostId(
    $postId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccommodationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accommodationByPostId(
      postId: $postId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accommodationParticipantByAccommodationId = /* GraphQL */ `
  query AccommodationParticipantByAccommodationId(
    $accommodationId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAccommodationParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accommodationParticipantByAccommodationId(
      accommodationId: $accommodationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        accommodationId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accommodationParticipantByUserIdByAccommodationId = /* GraphQL */ `
  query AccommodationParticipantByUserIdByAccommodationId(
    $userId: ID
    $accommodationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccommodationParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accommodationParticipantByUserIdByAccommodationId(
      userId: $userId
      accommodationId: $accommodationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        accommodationId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const activityByTripId = /* GraphQL */ `
  query ActivityByTripId(
    $tripId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityByTripId(
      tripId: $tripId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const activityByPostId = /* GraphQL */ `
  query ActivityByPostId(
    $postId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityByPostId(
      postId: $postId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const activityParticipantByActivityId = /* GraphQL */ `
  query ActivityParticipantByActivityId(
    $activityId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActivityParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityParticipantByActivityId(
      activityId: $activityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        activityId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const activityParticipantByUserIdByActivityId = /* GraphQL */ `
  query ActivityParticipantByUserIdByActivityId(
    $userId: ID
    $activityId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityParticipantByUserIdByActivityId(
      userId: $userId
      activityId: $activityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        activityId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const betaKeyByOwnerByEmail = /* GraphQL */ `
  query BetaKeyByOwnerByEmail(
    $owner: ID
    $email: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBetaKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    betaKeyByOwnerByEmail(
      owner: $owner
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        userId
        email
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const betaKeyByEmail = /* GraphQL */ `
  query BetaKeyByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelBetaKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    betaKeyByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        userId
        email
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentByPostId = /* GraphQL */ `
  query CommentByPostId(
    $postId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentByPostId(
      postId: $postId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentByPostIdCommentTypeByCreatedAt = /* GraphQL */ `
  query CommentByPostIdCommentTypeByCreatedAt(
    $postIdCommentType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentByPostIdCommentTypeByCreatedAt(
      postIdCommentType: $postIdCommentType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentsByRepliedToCommentId = /* GraphQL */ `
  query CommentsByRepliedToCommentId(
    $repliedToCommentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentsByRepliedToCommentId(
      repliedToCommentId: $repliedToCommentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentsByUserId = /* GraphQL */ `
  query CommentsByUserId(
    $owner: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentsByUserId(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const feedbackByCategoryByCreatedAt = /* GraphQL */ `
  query FeedbackByCategoryByCreatedAt(
    $category: FeedbackCategory
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedbackByCategoryByCreatedAt(
      category: $category
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        isUser
        title
        details
        category
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const flightByTripId = /* GraphQL */ `
  query FlightByTripId(
    $tripId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFlightFilterInput
    $limit: Int
    $nextToken: String
  ) {
    flightByTripId(
      tripId: $tripId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const flightByPostId = /* GraphQL */ `
  query FlightByPostId(
    $postId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFlightFilterInput
    $limit: Int
    $nextToken: String
  ) {
    flightByPostId(
      postId: $postId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const flightInformationByTripId = /* GraphQL */ `
  query FlightInformationByTripId(
    $tripId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFlightInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    flightInformationByTripId(
      tripId: $tripId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        flightId
        tripId
        owner
        departTime
        arrivalTime
        airline
        flightNumber
        departureAirport
        arrivalAirport
        flightPost {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const flightInformationByFlightId = /* GraphQL */ `
  query FlightInformationByFlightId(
    $flightId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFlightInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    flightInformationByFlightId(
      flightId: $flightId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        flightId
        tripId
        owner
        departTime
        arrivalTime
        airline
        flightNumber
        departureAirport
        arrivalAirport
        flightPost {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const flightParticipantByFlightId = /* GraphQL */ `
  query FlightParticipantByFlightId(
    $flightId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFlightParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    flightParticipantByFlightId(
      flightId: $flightId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        flightId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const flightParticipantByUserIdByFlightId = /* GraphQL */ `
  query FlightParticipantByUserIdByFlightId(
    $userId: ID
    $flightId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFlightParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    flightParticipantByUserIdByFlightId(
      userId: $userId
      flightId: $flightId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        flightId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const friendshipsByPrimaryUserIdByFriendshipStatus = /* GraphQL */ `
  query FriendshipsByPrimaryUserIdByFriendshipStatus(
    $primaryUserId: ID
    $friendshipStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    friendshipsByPrimaryUserIdByFriendshipStatus(
      primaryUserId: $primaryUserId
      friendshipStatus: $friendshipStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const friendshipsBySecondaryUserIdByFriendshipStatus = /* GraphQL */ `
  query FriendshipsBySecondaryUserIdByFriendshipStatus(
    $secondaryUserId: ID
    $friendshipStatus: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    friendshipsBySecondaryUserIdByFriendshipStatus(
      secondaryUserId: $secondaryUserId
      friendshipStatus: $friendshipStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const friendshipByPrimaryUserIdBySecondaryUserId = /* GraphQL */ `
  query FriendshipByPrimaryUserIdBySecondaryUserId(
    $primaryUserId: ID
    $secondaryUserId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    friendshipByPrimaryUserIdBySecondaryUserId(
      primaryUserId: $primaryUserId
      secondaryUserId: $secondaryUserId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const postLikeByPostId = /* GraphQL */ `
  query PostLikeByPostId(
    $postId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postLikeByPostId(
      postId: $postId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        owner
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const postLikeByOwner = /* GraphQL */ `
  query PostLikeByOwner(
    $owner: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPostLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postLikeByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postId
        owner
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentLikeByCommentId = /* GraphQL */ `
  query CommentLikeByCommentId(
    $commentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentLikeByCommentId(
      commentId: $commentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        commentId
        comment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentLikeByOwner = /* GraphQL */ `
  query CommentLikeByOwner(
    $owner: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCommentLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentLikeByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        commentId
        comment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const notificationsByOwnerStatusKeyByCreatedAt = /* GraphQL */ `
  query NotificationsByOwnerStatusKeyByCreatedAt(
    $ownerStatusKey: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOwnerStatusKeyByCreatedAt(
      ownerStatusKey: $ownerStatusKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        notificationType
        notificationStatus
        ownerStatusKey
        tripInvitationId
        friendshipId
        userId
        tripId
        commentId
        postId
        tripInvitation {
          id
          owners
          senderId
          recipientId
          tripId
          permissionType
          status
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        comment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        friendship {
          id
          primaryUserId
          secondaryUserId
          friendshipStatus
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const notificationsByOwnerByCreatedAt = /* GraphQL */ `
  query NotificationsByOwnerByCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOwnerByCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        notificationType
        notificationStatus
        ownerStatusKey
        tripInvitationId
        friendshipId
        userId
        tripId
        commentId
        postId
        tripInvitation {
          id
          owners
          senderId
          recipientId
          tripId
          permissionType
          status
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        comment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        friendship {
          id
          primaryUserId
          secondaryUserId
          friendshipStatus
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const postByTripId = /* GraphQL */ `
  query PostByTripId(
    $tripId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postByTripId(
      tripId: $tripId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const postByUserId = /* GraphQL */ `
  query PostByUserId(
    $owner: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postByUserId(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const resourcesByResourceName = /* GraphQL */ `
  query ResourcesByResourceName(
    $resourceName: String
    $sortDirection: ModelSortDirection
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    resourcesByResourceName(
      resourceName: $resourceName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        resourceName
        description
        resourcePath
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const transportationByTripId = /* GraphQL */ `
  query TransportationByTripId(
    $tripId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTransportationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transportationByTripId(
      tripId: $tripId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const transportationByPostId = /* GraphQL */ `
  query TransportationByPostId(
    $postId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTransportationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transportationByPostId(
      postId: $postId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const transportationParticipantByTransportationId = /* GraphQL */ `
  query TransportationParticipantByTransportationId(
    $transportationId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTransportationParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transportationParticipantByTransportationId(
      transportationId: $transportationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        transportationId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const transportationParticipantByByUserIdTransportationId = /* GraphQL */ `
  query TransportationParticipantByByUserIdTransportationId(
    $userId: ID
    $transportationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTransportationParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transportationParticipantByByUserIdTransportationId(
      userId: $userId
      transportationId: $transportationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        transportationId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listTripsByOwnerByCreatedAt = /* GraphQL */ `
  query ListTripsByOwnerByCreatedAt(
    $owner: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTripsByOwnerByCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const tripMemberByUser = /* GraphQL */ `
  query TripMemberByUser(
    $userId: ID
    $tripId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripMemberByUser(
      userId: $userId
      tripId: $tripId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        tripId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        permissionType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const tripMemberByTrip = /* GraphQL */ `
  query TripMemberByTrip(
    $tripId: ID
    $userId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripMemberByTrip(
      tripId: $tripId
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        tripId
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        permissionType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const tripInvitationByTripIdByStatus = /* GraphQL */ `
  query TripInvitationByTripIdByStatus(
    $tripId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripInvitationByTripIdByStatus(
      tripId: $tripId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const tripInvitationBySenderByStatus = /* GraphQL */ `
  query TripInvitationBySenderByStatus(
    $senderId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripInvitationBySenderByStatus(
      senderId: $senderId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const tripInvitationByRecipientByStatus = /* GraphQL */ `
  query TripInvitationByRecipientByStatus(
    $recipientId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripInvitationByRecipientByStatus(
      recipientId: $recipientId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByUsernameById = /* GraphQL */ `
  query UserByUsernameById(
    $username: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByUsernameById(
      username: $username
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
